module.exports = __webpack_public_path__ + "static/media/refer_gift_icon.2be93a0e.png";